<style scoped>
    .info_page {
        background: #f7f7f7;
    }

    .info_tips {
        width: 100%;
        height: 0.36rem;
        background: #e6ebff;
        color: #5983fc;
        font-size: 0.14rem;
        text-align: center;
        line-height: 0.36rem;
    }

    .user_info {
        background: #ffffff;
    }

    .user_ingo_line {
        width: 0.04rem;
        height: 0.13rem;
        background: linear-gradient(
                135deg,
                rgba(89, 131, 252, 1) 0%,
                rgba(60, 113, 246, 1) 100%
        );
        display: inline-block;
    }

    .user_info_title {
        height: 0.42rem;
        padding: 0 0.15rem;
        display: flex;
        align-items: center;
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_info_txt {
        margin-left: 0.06rem;
        color: #333333;
        font-weight: bold;
        font-size: 0.14rem;
    }

    .choose_user_info {
        padding: 0 0.15rem;
    }

    .user_box {
        width: 100%;
        height: 0.5rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: #333333;
        font-size: 0.14rem;
    }

    .user_box_bot {
        border-bottom: 0.01rem solid #f5f5f5;
    }

    .user_box_right {
        display: flex;
        align-items: center;
    }

    .user_box_right img {
        width: 0.1rem;
        height: 0.1rem;
        margin-left: 0.1rem;
    }

    .choose_color {
        color: #999999;
    }

    .btn {
        /* margin-top: 0.1rem; */
        width: 100%;
        height: 0.5rem;
        background: linear-gradient(
                132deg,
                rgba(89, 163, 252, 1) 0%,
                rgba(60, 100, 246, 1) 100%
        );
        font-size: 0.17rem;
        color: #ffffff;
        font-weight: bold;
        line-height: 0.5rem;
        text-align: center;
    }

</style>
<template>
    <div class="info_page">
        <div class="info_tips">信息仅用于审批借款额度，资料将被加密保护</div>
        <div class="user_info">
            <div class="user_info_title">
                <div class="user_ingo_line"></div>
                <span class="user_info_txt">基本信息</span>
            </div>
            <div class="choose_user_info">

                <!-- 工作地址 -->
                <div class="user_box user_box_bot" @click="choiceCity">
                    <div>工作地址</div>
                    <div class="user_box_right">
                        <span v-if="userCity==''" class="choose_color">请选择</span>
                        <span v-else>{{ userCity }}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showCityChoose" round position="bottom">
                    <van-area
                            title="请选择地区"
                            :area-list="areaList"
                            @cancel="showCityChoose = false"
                            @confirm="confirmCity"
                    />
                </van-popup>

                <!-- 借款金额 -->
                <div
                        class="user_box user_box_bot"
                        @click="showMoneyPicker = true"
                >
                    <div>借款金额</div>
                    <div class="user_box_right">
                        <span v-if="userMoney==''" class="choose_color">请选择</span>
                        <span v-else>{{userMoney}}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showMoneyPicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsMoney"
                            @cancel="showMoneyPicker = false"
                            @confirm="onConfirmMoney"
                    />
                </van-popup>
                <!-- 借款期限 -->
                <div class="user_box user_box_bot" @click="showDatePicker = true">
                    <div>借款期限</div>
                    <div class="user_box_right">
                        <span v-if="userDate==''" class="choose_color">请选择</span>
                        <span v-else>{{userDate}}</span>
                        <img src="@/assets/img/vip/right_tip.png" alt=""/>
                    </div>
                </div>
                <van-popup v-model="showDatePicker" round position="bottom">
                    <van-picker
                            show-toolbar
                            :columns="columnsDate"
                            @cancel="showDatePicker = false"
                            @confirm="onConfirmDate"
                    />
                </van-popup>
            </div>
        </div>

        <Loading :isShow="isLoading"></Loading>

        <!-- btn -->
        <div class="btn"
             @click="submit">
            提交
        </div>

    </div>
</template>

<script>
    import areaList from '../../libs/area.js'
    import Loading from "@/components/loading";

    export default {
        components: {Loading},
        data() {
            return {
                areaList, //地区列表
                province: "", //省
                city: "", //城市
                area: "", //区
                provinceCode: "", //省编号
                cityCode: "", //市编号
                areaCode: "", //区/县编号
                tips: "未完善，请填写完整后再保存~",
                showCityChoose: false, //选择城市列表
                userCity: "", //选择城市
                userMoney: "", //用户借款金额
                userDate: "", //用户借款期限
                showMoneyPicker: false, //选择借款金额
                showDatePicker: false, //选择借款期限
                columnsMoney: [], //借款金额列表
                columnsDate: [], //借款期限列表
                productId: 0,
                hasLocation:false,
                isLoading: false,
            };
        },
        created() {
            this.startLocation();
            window.saveLocation = this.saveLocation;
            this.productId = this.$route.query.productId;
            this.getHeadProduct();
        },
        mounted() {
            this.util.title("提升额度");
        },
        methods: {
            submit() {
                this.saveCustomerBaseInfo();
            },
            confirmCity(value) {
                if (value[2]) {
                  if (value[2].name === "请选择") {
                    this.showCityChoose = false;
                  } else {
                    this.province = value[0].name;
                    this.provinceCode = value[0].code;
                    this.city = value[1].name;
                    this.cityCode = value[1].code;
                    this.area = value[2].name;
                    this.areaCode = value[2].code;
                    this.userCity = value[0].name + value[1].name + value[2].name;
                  }
                } else {
                    this.userCity = value[0].name + value[1].name;
                }
                this.showCityChoose = false;
            },
            onConfirmMoney(value) {
                this.userMoney = value.text;
                this.showMoneyPicker = false;
            },
            onConfirmDate(value) {
                this.userDate = value.text;
                this.showDatePicker = false;
            },
            getNewInfo() {
                let params = {
                    productId: this.productId
                };
                this.$get("/app/v1/product/baseinfo/getAllBaseInfo", params)
                    .then((res) => {
                        if (res.code == 200) {
                            let resInfo = res.data.baseInfoConfig[0].list;
                            for (var i = 0; i < resInfo.length; i++) {
                                if (resInfo[i] && resInfo[i].paramField.includes("money")) {
                                    resInfo[i].showConfig.split(",").forEach((item, index) => {
                                        this.columnsMoney.push({num: index, text: item});
                                    });
                                }
                                if (resInfo[i] && resInfo[i].paramField.includes("stage")) {
                                    resInfo[i].showConfig.split(",").forEach((item, index) => {
                                        this.columnsDate.push({num: index, text: item});
                                    });
                                }
                            }
                        }
                    });
            }, getHeadProduct() {
                if (this.productId > 0) {
                    this.getNewInfo();
                } else {
                    this.$get("/app/v1/appHead/product/bySite?site=2")
                        .then((res) => {
                            if (res.code == 200) {
                                let data = res.data;
                                if (data) {
                                    this.productId = data.productId;
                                    this.getNewInfo();
                                }
                            }
                        });
                }
            },
            saveCustomerBaseInfo() {
                let canSubmit = true;
                if (this.userCity == "") {
                    this.util.toast({msg: "工作地址" + this.tips});
                    canSubmit = false;
                    return;
                }else if (this.city == "") {
                    this.util.toast({msg: "工作地址" + this.tips});
                    canSubmit = false;
                    return;
                } else if (this.userMoney == "") {
                    canSubmit = false;
                    this.util.toast({msg: "借款金额" + this.tips});
                    return;
                } else if (this.userDate == "") {
                    canSubmit = false;
                    this.util.toast({msg: "借款期限" + this.tips});
                    return;
                }
                let newInfoArr = {
                    //新增字段
                    workCity: this.userCity,
                };
                let moneyProduct = "money" + this.productId;
                newInfoArr[moneyProduct] = this.userMoney;
                let stageProduct = "stage" + this.productId;
                newInfoArr[stageProduct] = this.userDate;
                const baseParam = {
                    proBaseInfo: JSON.stringify(newInfoArr),
                    province: this.province,
                    city: this.city,
                    area: this.area,
                    provinceCode: this.provinceCode,
                    cityCode: this.cityCode,
                    areaCode: this.areaCode,
                    productId: this.productId
                }
                return this.$post("/app/v1/product/baseinfo/saveCustomerBaseInfo", baseParam).then((res) => {
                    if (res.code == 200 && res.data == 1) {
                        this.addCustomerAuth();
                    } else {
                        this.util.toast({msg: res.msg});
                    }
                    return res;
                });
            }, addCustomerAuth() {
                let param = {
                    authId: 30
                };
                return this.$post("/app/api/v1/addCustomerAuth", param).then((res) => {
                    if (res.code == 200) {
                        this.authSuccess();
                    } else {
                        this.util.toast({msg: res.msg});
                    }
                    return res;
                });
            }, authSuccess() { //调用android和ios的方法
                console.log("调用原生方法")
                try {
                    window.webkit.messageHandlers.authSuccess.postMessage(""); //ios
                } catch (err) {
                    window.AppJs.authSuccess(); //android
                }
            },startLocation(){
                this.isLoading = true;
                try {
                    try {
                        window.webkit.messageHandlers.startLocation.postMessage(""); //ios
                    } catch (err) {
                        window.AppJs.startLocation(); //android
                    }
                }catch (e) {
                    this.isLoading = false;
                }
            },saveLocation(str){
                this.isLoading = false;
                if(str){
                    this.hasLocation=true;
                }
                var param = JSON.parse(str);
                var city=[{code:param.cityCode,name:param.province},{code:param.cityCode,name:param.city},{code:param.cityCode,name:param.district}]
                this.confirmCity(city)
            },choiceCity(){
                if(this.hasLocation){
                    this.showCityChoose = false;
                }else{
                    this.showCityChoose = true
                }
            },


        },
    };
</script>
